var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 9.17969H15.7716V5.16455C15.7716 2.3168 13.406 0 10.4982 0C7.59043 0 5.22476 2.3168 5.22476 5.16455V9.17969H3.46875C1.85332 9.17969 0.539062 10.4939 0.539062 12.1094V22.0703C0.539062 23.6857 1.85332 25 3.46875 25H17.5312C19.1467 25 20.4609 23.6857 20.4609 22.0703V12.1094C20.4609 10.4939 19.1467 9.17969 17.5312 9.17969ZM7.17788 5.16455C7.17788 3.39375 8.66738 1.95312 10.4982 1.95312C12.329 1.95312 13.8185 3.39375 13.8185 5.16455V9.17969H7.17788V5.16455ZM18.5078 22.0703C18.5078 22.6088 18.0697 23.0469 17.5312 23.0469H3.46875C2.93027 23.0469 2.49219 22.6088 2.49219 22.0703V12.1094C2.49219 11.5709 2.93027 11.1328 3.46875 11.1328H17.5312C18.0697 11.1328 18.5078 11.5709 18.5078 12.1094V22.0703Z",
    fill: "#396AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a448ac81bf2675135a1150f1c6e0fb68.svg";
export { ForwardRef as ReactComponent };